module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/down_calificacion.f88238db.svg";